import UmuWebview from '@umu/umu-webview';
import { $window } from '@umu/umu-dom';
import { fetch } from '@umu/umu-fetch';
import { ImgUploadSourceType as SourceType } from '@umu/umu-types';
import { LANG } from './webview';

interface IUploadImageToServerInput {
    media_id: string;
}

interface IUploadImageToServerOutput {
    data: {
        photo_url: string;
    };
}

export function uploadImageToServer(param: IUploadImageToServerInput): Promise<IUploadImageToServerOutput> {
    const postData = Object.assign(
        {
            session_id: '0',
            media_id: '',
            title: 'image',
            rotate: 0,
            type: 2,
        },
        param,
    );
    return fetch.post('/ajax/result/uploadphoto', postData);
}

// 微信中上传
const savePhotoListInWx = (photoList: string[]): Promise<string[]> => {
    const list = photoList.concat([]);
    const completeList: string[] = [];

    return new Promise((resolve, reject) => {
        const syncUpload = () => {
            const item = list.shift();
            if (!item) {
                return;
            }
            wx.uploadImage({
                localId: item,
                isShowProgressTips: 1,
                success(res) {
                    const mediaId = res.serverId;
                    const done = () => {
                        if (list.length === 0) {
                            resolve(completeList);
                        } else {
                            syncUpload();
                        }
                    };
                    uploadImageToServer({ media_id: mediaId })
                        .then((data) => {
                            completeList.push(data.data.photo_url);
                            done();
                        })
                        .catch(() => {
                            done();
                        });
                },
                fail(e) {
                    reject(e);
                },
            });
        };
        syncUpload();
    });
};

/**
 * 微信上传图片
 * @param sourceType album camera
 * @param count 0 不限 1 单选 其他 多选限制几张
 */
export const choosePhotoByWx = (sourceType: SourceType, count: number): Promise<string[]> => {
    return new Promise((resolve, reject) => {
        let inIframe = false; // 组件是否在iframe中
        if (self !== top) {
            inIframe = true;
        }

        const topWindow = parent.parent || {};
        const wx = $window.wx || (inIframe && topWindow.wx);
        wx.chooseImage({
            count,
            sourceType: [sourceType],
            success(result: any) {
                if (result.errMsg === 'chooseImage:ok') {
                    const data = result.localIds;
                    savePhotoListInWx(Array.isArray(data) ? data : [data]).then(
                        (res) => {
                            resolve(res);
                        },
                        (e) => {
                            reject(e);
                        },
                    );
                }
            },
            fail(e: any) {
                reject(e);
            },
        });
    });
};

/**
 * APP 上传图片
 * @param sourceType
 * @returns string[]
 */
export const choosePhotoByApp = (sourceType: SourceType, count: number) => {
    return new Promise((resolve, reject) => {
        UmuWebview.registerHandler('receivePhoto', (data, _callback) => {
            if (!data.success) {
                reject(data);
            }

            if (data.imgUrl) {
                resolve([data.imgUrl]);
            } else if (data.imgArr) {
                const list = data.imgArr || [];
                resolve(list);
            }
        });

        UmuWebview.callHandler(
            'getPhoto',
            {
                type: sourceType,
                count,
            },
            (_data: any) => {
                //
            },
            LANG,
        );
    });
};
